import { Text } from 'blaze-ui/Text/Text'
import Styles from './NotificationItem.module.scss'
import { NotificationFolder as NotificationFolderType } from './types'
import { FolderIcon } from 'common/FolderIcon'

interface Props {
  folder: NotificationFolderType
}

export const NotificationFolder = ({ folder }: Props) => {
  return (
    <div className={Styles.file}>
      <FolderIcon header_emoji={folder.emoji || null} className={Styles.folderEmoji} />
      <Text lineClamp={1} variant="placeholder" color="var(--dark-80)">
        {folder.title}
      </Text>
    </div>
  )
}
